// extracted by mini-css-extract-plugin
export default {"search-bar-input":"vbWzCyT68Ad9x7jMLXFw","searchBarInput":"vbWzCyT68Ad9x7jMLXFw"};